module.exports = __webpack_public_path__ + "static/media/Spinner.65e4c549.svg";